<template lang="pug">
  div
    p.mb-1.text-info(v-if="combinations.length && !parsed_combinations.length") Ya has creado todas las combinaciones disponibles.
    b-form-group.mb-1(:disabled="!parsed_combinations.length")
      b-input-group
        b-input-group-prepend.d-none.d-md-block
          b-input-group-text.bg-light Valores
        b-form-select(v-model="new_value", @change="createVariant($event)")
          option(:value="null", disabled) {{ !parsed_combinations.length ? 'No hay más combinaciones disponibles' : '--Selecciona valor--' }}
          option(v-for="combination in parsed_combinations", :key="combination.value", :value="combination.value") {{combination.title}}
    .mb-3
      b-link.text-sm(variant="info" v-if="combinations.length && parsed_combinations.length" @click="addAllVariants(parsed_combinations)") Agregar todos los valores
    b-card.mb-0(no-body)
      b-list-group
        b-list-group-item(v-if="!parsed_variants.length")
          p.mb-0 No hay variantes creadas
        b-list-group-item(v-for="(item, index) in parsed_variants", :key="index")
          b-row
            b-col
              b-row.mb-2
                b-col
                  p.mb-0 {{ item.title}}
                b-col(cols="auto")
                  b-form-checkbox.mr-3(switch, size="sm" v-model="item.enabled" @change="item.changed = true") Habilitado
              b-form-row
                b-col
                  b-form-group.mb-1(label="Descripción")
                    b-form-input(placeholder="Descripción", size="sm", v-model="item.description", max-rows="2", no-resize, :disabled="item.loading" @input="item.changed = true;")
                b-col(cols="auto")
                  b-form-group.mb-1(label="Precio")
                    b-input-group.mb-2
                      b-input-group-prepend
                        b-input-group-text
                          dollar-sign-icon.icon-sm
                      b-form-input(type="number", v-model="item.price", placeholder="0.00", min="0", size="sm", :disabled="item.loading", :state="item.validated_price ? parseFloat(item.price) >= 0 : null" style="max-width:100px;" @input="item.changed = true;")
                b-col(cols="auto")
                  b-form-group.mb-0(label="Inventario")
                    b-form-input(type="number", v-model="item.stock", placeholder="0", min="0", size="sm", :disabled="item.loading", :state="item.validated_stock ? item.stock >= 0 : null" style="max-width:100px;" @input="item.changed = true;")
              b-row.justify-content-end
                //- b-col
                //-   b-img.mr-3(v-for="n in 3" width="50" height="50" rounded blank blank-color="#f2f2f2")
                b-col.d-flex.align-items-center(cols="auto")
                  trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="destroyVariantValue(item)")
                  b-button.ml-3.text-sm.p-1.px-4(:variant="item.changed ? 'primary' : 'light'" size="sm" :disabled="item.loading || !item.changed" @click="updateVariant(item)") Guardar
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const product_variantController = createNamespacedHelpers('product_variant')
const variantController = createNamespacedHelpers("variant");

import _debounce from 'lodash.debounce'

export default {
  data () {
    return {
      loading: false,
      fields: [
        {key: 'title', label: 'Variante'},
        {key: 'description', label: 'Descripción'},
        {key: 'stock', label: 'Inventario'},
        {key: 'price', label: 'Precio'},
        {key: 'enabled', label: 'Acciones'},
      ],
      new_value: null,
    }
  },
  computed: {
    ...product_variantController.mapState({
      product_variants: state => state.product_variants,
      combinations: state => state.combinations
    }),
    ...variantController.mapState({
      variants: state => state.variants
    }),
    parsed_variants () {
      let self = this
      return this.product_variants.map(v => {
        v.loading = false
        v.validated_price = false
        v.validated_stock = false
        v.title = self.parseValues(v.value)
        return v
      })
    },
    isPriceOk () {
      return parseFloat(this.local_price) >= 0
    },
    parsed_combinations () {
      let self = this
      return this.combinations.filter(c => !this.product_variants.map(v => v.value).includes(c)).map(c => {
        let title = self.parseValues(c)
        return {
          value: c,
          title: title
        }
      })
    }
  },
  methods: {
    ...mapActions([
      'product_variant/all',
      'product_variant/create',
      'product_variant/update',
      'product_variant/destroy',
      'product_variant/combination_variants',
    ]),
    getAll () {
      let self = this
      this.loading = true

      this['product_variant/all']({
        product_id: self.$route.params.product_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            this.$nextTick(() => {
              if (this.product_variants.length) {
                this.getCombinations()
              }
            })
          }
        }
      })
    },
    addAllVariants (variants) {
      let self = this
      let promises = []

      this.showLoadingScreen()

      for (let variant of variants) {
        promises.push(new Promise(resolve => {
          this['product_variant/create']({
            product_id: self.$route.params.product_id,
            value: variant.value,
            callback: res => {
              resolve()
            }
          })
        }))
      }

      Promise.all(promises).then(results => {
        this.hideLoadingScreen()
        self.$message.success('Valores agregados con éxito')
      })
    },
    createVariant (value) {
      let self = this
      this.loading = true

      this['product_variant/create']({
        product_id: self.$route.params.product_id,
        value: value,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Valor agregado')
            self.new_value = null
          }
        }
      })
    },
    updateVariant (variant, key) {
      let self = this
      variant.loading = true

      if(parseFloat(variant.price) < 0 || variant.stock < 0) {
        variant['validated_' + key] = true
        variant.loading = false
        this.$root.$emit('bv::refresh::table', 'p_v_v_table')
        return
      }

      this['product_variant/update']({
        product_id: self.$route.params.product_id,
        ...variant,
        callback: res => {
          variant.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            variant.changed = false
            self.$message.success('Variante actualizada')
            this.$root.$emit('bv::refresh::table', 'p_v_v_table')
            if(key) variant['validated_' + key] = false
          }
        }
      })
    },
    destroyVariantValue (variant) {
      let self = this
      variant.loading = true

      this['product_variant/destroy']({
        product_id: self.$route.params.product_id,
        ...variant,
        callback: res => {
          variant.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Valor eliminado')
          }
        }
      })
    },
    getCombinations () {
      let self = this
      this.loading = true

      this['product_variant/combination_variants']({
        product_id: self.$route.params.product_id,
        callback: res => {
          self.loading = false
          if (res.error) {
            // self.$message.error(res.error)
          }
        }
      })
    },
    parseValues (value) {
      return value.split("-").map(v => {
        let variant = v.split(":")
        if (variant[1]) {
          try {
            for (let v of this.variants) {
              for (let vv of v.Variant_Values) {
                if (parseInt(vv.variant_value_id) == parseInt(variant[1])) {
                  return v.name + " " + variant[0].replace("_", " ")
                }
              }
            }
          } catch (e) {
            console.log(e.message);
          }
        }
        return variant[0].replace("_", " ")
      }).join(" - ")
    }
  },
  mounted () {
    this.getAll()
    //this.getCombinations()
  },
  watch: {

  }
}
</script>

<style lang="scss" scoped>

</style>
